'use client';

import React, { type ReactNode } from 'react';

import { Caption } from '@depop/web-thrift-ui/Typography';

import styles from './styles.module.css';

export type NudgePillProps = {
  icon?: ReactNode;
  text: string;
  testId?: string;
  className?: string;
};

export function NudgePill({ icon, text, testId, className }: NudgePillProps) {
  return (
    // eslint-disable-next-line no-restricted-syntax
    <div data-testid={testId} className={`${className} ${styles.container}`}>
      {icon}
      <Caption colour="base" variant="lg-regular" className={styles.nudgeText}>
        {text}
      </Caption>
    </div>
  );
}
